import api from '@/apis/di/projectAPI.js';
import {usefilterActionCombo} from './filterActionCombo.js';
import {getCurrentInstance} from 'vue';

// Combo grid CTMT
export const useProjectSubComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const {proxy} = getCurrentInstance();
  const {extendFilter} = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onProjectSubComboboxLoadData = (payload, row, column) => {
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [
      {Field: 'object_type', Value: 2},
      {Field: 'inactive', Value: false, Ors: ors},
    ];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'project_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const projectSubComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã CTMT, dự án',
        dataField: 'project_code',
        width: 140,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên CTMT, dự án',
        dataField: 'project_name',
        width: 310,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
      {
        title: 'Loại',
        dataField: 'object_type_name',
        width: 140,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ],
    displayField: 'project_code',
    valueField: 'project_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onProjectSubComboboxLoadData,
  };

  return {
    projectSubComboConfig,
    onProjectSubComboboxLoadData, // trả về thêm để dùng chung chả cả combo ko thuộc grid
  };
};
